import React, { useState, useEffect } from 'react';
import { Tabs } from '@b-design/fusion';
import Release from './component/release';
import VersionInfo from './component/versionInfo';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import AppInfo from '@/components/AppInfo';

import './index.less';

const Version: React.FC = () => {
  const { appId, channelCode, version, spaceId } = getQueryStringArgs();
  const [historyList, setHistoryList] = useState<any>([]);
  // const [versionInfos, setVersionInfos] = useState({});
  const [versionDetail, setVersionDetail] = useState<any>({});
  // 初始化数据
  const initDataSource = () => {
    Requests.get('/rest/intercnn/app/publish/version/detail', {
      appId,
      channelCode,
      version,
    }).then((data) => {
      if (data) {
        setVersionDetail(data);
      }
    });
    Requests.get('/rest/intercnn/app/publish/version/history/query', {
      appId,
      channelCode,
      version,
    }).then((data) => {
      if (data) {
        setHistoryList(data);
      }
    });
  };

  useEffect(() => {
    initDataSource();
  }, []);

  const breadcrumbConfig = [
    {
      key: 'miniapp',
      breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationList', dm: '应用列表' }),
      path: `/miniapp`,
    },
    {
      key: 'details',
      breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationDetails', dm: '应用详情' }),
      path: `/miniapp/detail`
    },
    {
      key: 'version',
      breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationVersion', dm: '应用版本' }),
    },
  ];

  return (
    <div className="miniapp-version">
      <CommonHeader
        title={versionDetail?.versionDescription?.name}
        backTo={`/miniapp/detail?spaceId=${spaceId || ''}&appId=${appId}`}
        breadcrumbs={breadcrumbConfig}
      />
      <AppInfo versionDetail={versionDetail} />
      <div className="version-container">
        <Tabs defaultActiveKey='Release'>
          <Tabs.Item
            title={$i18n.get({
              id: 'aopf.pages.miniapp.Version.tabs.Version.Info',
              dm: '版本信息',
            })}
            key="VersionInfo"
          >
            <VersionInfo versionInfos={versionDetail} />
          </Tabs.Item>
          <Tabs.Item
            title={$i18n.get({ id: 'aopf.pages.miniapp.Version.tabs.Release', dm: '发布' })}
            key="Release"
          >
            <Release
              historyList={historyList}
              versionDetail={versionDetail}
              initDataSource={initDataSource}
              spaceId={spaceId || ''}
            />
          </Tabs.Item>
        </Tabs>
      </div>
    </div>
  );
};
export default Version;
